module.exports = __webpack_public_path__ + "static/img/3.9d6c867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/3.png
// module id = nMsN
// module chunks = 1